import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";
import axios from "../../../../utils/axiosInceptor";

type UpdateNoteOptions = {
  noteId: string;
  isPinned: boolean;
};

const updateNote = async (options: UpdateNoteOptions) => {
  const { noteId, isPinned } = options;

  const url = `${apiV1Endpoint}/notes/${noteId}`;
  const response = await axios.patch<ApiResponse>(url, { isPinned });
  return response.data.result;
};

type UseUpdateNoteOptions = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useUpdateNote = (options: UseUpdateNoteOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isSuccess } = useMutation({
    mutationFn: updateNote,
    onSuccess,
    onError,
  });

  return {
    updateNote: mutateAsync,
    isSuccess,
  };
};
